import { createContext, PropsWithChildren } from 'react';

interface ImageMetadata {
   imageUrl: string;
   width: number;
   height: number;
}

export const ImageContext = createContext<ImageMetadata>({
   imageUrl: '',
   width: 0,
   height: 0,
});

export function ImageContextProvider({ children, ...imageMeta }: PropsWithChildren<ImageMetadata>) {
   return <ImageContext.Provider value={imageMeta}>{children}</ImageContext.Provider>;
}
